import React, { useContext, useEffect, useMemo, useState } from "react";
import { ToastMessageContext } from "lib/contexts/message_context";
import { MaintenanceServices } from "lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation";
import { getOrganisationId, getUserId } from "lib/utils/common_utils";
import UnlockIcon from "assets/Unlock.png";
import lock from "assets/icons/Lock.svg";
import CustomerSection from "./Sections/CustomerSection";
import WorkScopeSection from "./Sections/WorkScopeSection";
import PricingSection from "./Sections/PricingSection";
import ProjectPartSection from "./Sections/ProjectPartSection";
import { WorkshopContext } from "../WorkshopContext/WorkshopContext";
import { Grid, useTheme, Box } from "@material-ui/core";
import useQuoteStyles from "./utils/QuoteStyles";
import MROButton from "components/buttons";
import AcceptanceSection from "./Sections/AcceptanceSection";
import QuotePreview from "../QuotePopUp/QuotePreview";
import { validateFormData } from "lib/utils/helperFunctions";
import MessagePopup from "components/universal/messagePopup";


function Quote(props) {
    const {
        workshopOrder,
        quoteId,
        action,
        getMaintenanceOrderList,
        handleClose,
        setAction,
        quoteStatus = false,
        workshop_id_maint,
        statuFlag,
        readOnly,
        readAndWrite,
        editTab,
        setEditTab,
        tabStatus,
        currentSelection,
        getWorkshopOrderDetails,
        actionStoppedOrder,
        tabId,
        setQuoteId
    } = props;

    const classes = useQuoteStyles()


    const {
        state,
        setState,
        shouldTabDataUpdate,
        setShouldTabDataUpdate,
        editButton,
        setEditButton,
        setTabStatus,
        setEditTabStatus,
    } = useContext(WorkshopContext);
    const message = useContext(ToastMessageContext);
    const [rate, setRate] = useState(1)
    const [errors, setErrors] = useState({});
    const [disabled, setDisabled] = useState(
        action === "Send Quote " || quoteStatus === false ? false : true
    );
    const [standardId, setStandardId] = useState(null)
    const [cusExist, setExistCus] = useState('yes');
    const [selectedCustomerId, setSelectedCustomerId] = useState({});
    const [access, setAccess] = useState({ read: false, write: true });
    const [quotation, setQuotation] = useState([]);
    const [priceBreakDetails, setPriceBreaksDetails] = useState([])
    const [salesRate, setSalesRate] = useState(null);
    const [loading, setLoading] = useState(false)
    const [selectedPart, setSelectedPart] = useState({});
    const [actions, setActions] = useState("");
    const [buttonStatus, setButtonStatus] = useState(false);
    const [disabledAccptance, setDisabledAcceptance] = useState(false);
    const [currentSelectedData, setCurrentSelectedData] = useState({})
    const [qty, setQty] = useState();
    const [currencyName, setCurrencyname] = useState(null);
    const [input, setInput] = useState({
        labour: "",
        parts: "",
        services: "",
        equipment: "",
        aog_fee: "",
    });
    const [button, setButton] = useState(false);
    const [projectParts, setProjectParts] = useState([])
    const [isGettingDetails, setIsGettingDetails] = useState(false);
    const [busy, setBusy] = useState(null);
    const [editStatus, setEditStatus] = useState(false);
    const [sum, setSum] = useState(null);
    const [projectState, setProjectstate] = useState(false);
    const [internalNotes, setInternalNotes] = useState('')
    const [internalFiles, setInternalFiles] = useState([])
    const [quantityPrice, setQuantityPrice] = useState('no');
    const [detailedBreakDown, setDetailedBreakDown] = useState('no');
    const [quoteComments, setQuoteComments] = useState(null);
    const theme = useTheme()
    const [updateQuoteLoading, setUpdateQuoteLoading] = useState(null);
    const [quoteCrete, setQuoteCreate] = useState(null);
    const [priceAllDetails, setPriceAllDetails] = useState([])
    const [quotePreview, setQuotePreview] = useState(false)
    const [popupValues, setPopUpValues] = useState({})
    const [tatQuantity, setTatquantity] = useState();
    const [states, setStates] = useState({ man_hours: '' });
    const [payload, setPayload] = useState({})
    const [messagePopup, setMessagePopup] = useState(false);
    const [reportableType, setReportableType] = useState(null)
    const [workshop_order_id, setWorkshopOrderId] = useState(null)


    useEffect(() => {
        if (workshopOrder != undefined && workshopOrder?.id !== undefined) {
            setWorkshopOrderId(workshopOrder?.id)
        }
        else if (currentSelection !== undefined && currentSelection?.id) {

            setWorkshopOrderId(currentSelection?.id)
        }
        else if (quotation !== undefined && quotation?.workshop_order_id) {
            setWorkshopOrderId(quotation?.workshop_order_id)
        }
        else {
            setWorkshopOrderId(workshop_id_maint)

        }

    }, [currentSelection, quotation, workshopOrder])

    useEffect(() => {
        if (!tabStatus) return;
        else {
            setDisabledAcceptance(true);
        }
    }, [tabStatus]);

    useEffect(() => {
        if (readOnly) {
            setAccess({ read: true, write: false });
            return;
        }

        if (readAndWrite) {
            setAccess({ read: false, write: true });
            return;
        }
    }, [readAndWrite, readOnly]);

    useEffect(() => {
        setState((ps) => ({ ...ps, isEditing: editTab, tab: "quote", warningDialogState: false }));

        return () => setState((ps) => ({ ...ps, tab: null }));
    }, [editTab]);

    useEffect(() => {
        setLoading(action === "Send Quote ");
    }, []);

    const handleWarningDialog = () => {
        setEditTabStatus(false)
        setState((ps) => ({ ...ps, warningState: true }));
    }

    const handleQuoteUnlockButton = () => {
        handleWarningDialog()
        setButton(true);
        setDisabled(false);
        // setAction("Send Quote");
    };
    const handleSaveForLater = () => {
        handleWarningDialog()
        setActions("save_for_later");
        setDisabled(false);
    };


    const handleEditAPiCall = async () => {
        if (disabledAccptance === false) {
            setIsGettingDetails(true);
            const param = {
                workshop_order_id: currentSelection?.id,
                tab: "quotation",
            };
            await MaintenanceServices.editButton(param)
                .then((res) => {
                    setBusy(null);
                    if (res.success) {
                        getWorkshopOrderDetails();
                        setEditStatus(!editStatus);
                        setTabStatus(false);
                        setEditButton(!editButton);
                        setBusy(null);
                    }
                })
                .catch((err) => {
                    message.showToastMessage({
                        message: "Something went wrong. Try again!",
                        variant: "error",
                    });
                    setBusy(null);
                })
                .finally(() => {
                    setIsGettingDetails(false);
                });
        }
    };

    useEffect(() => {
        if (editButton) {
            handleEditAPiCall();
        }
    }, [editButton]);

    const handleCloseTab = () => {
        getQuotation();
        getWorkshopOrderDetails();
        setEditTab(!editTab);
        setDisabledAcceptance(!disabledAccptance);
        setQuotation(null)
    };



    useEffect(() => {
        if (action === "Unlock" && quoteId != null) {
            getQuotation();
        }
    }, []);


    const getQuotation = async (id) => {
        // setLoading(true);
        setIsGettingDetails(true);
        await MaintenanceServices?.getQuotation(quoteId ?? id)
            .then((res) => {
                if (res) {
                    setQuotation(res.data);
                    setShouldTabDataUpdate(false);
                }
                // setLoading(false);
            })
            .catch((err) => {
                message.showToastMessage({
                    message: "Something went wrong. Try again!",
                    variant: "error",
                });
                // setLoading(false);
            })
            .finally(() => {
                setIsGettingDetails(false);
            });
    };



    const resetErrorsHandler = (name) => {
        setErrors((e) => ({ ...e, [name]: false }));
    };



    const handlePopup = () => {
        if (action === "Send Quote " || quoteId == null || quoteId === undefined || quotation?.quote_accepted === null || button) {
            setState((ps) => ({ ...ps, warningDialogState: true, isEditing: editTab }));
        }
    };
    useEffect(() => {
        if (action === "Unlock") {
            if (quotation !== null) {
                let obj = {
                    id: quotation?.line_customer_id,
                    name: quotation?.customer_name,
                    currency: {
                        currency_name: quotation?.currency_name,
                        sales_rate: quotation?.sales_rate
                    }

                };
                setSelectedCustomerId(obj);
            }
            let obj2 = {
                id: quotation?.primary_part_id,
                part_number: quotation?.part_number
            }
            setSelectedPart(obj2)
            if (quotation?.linked_storage_order_id === null) {
                setExistCus(
                    quotation?.customer_existing === true
                        ? "yes"
                        : quotation?.customer_existing === false
                            ? "no"
                            : ""
                );
            }

            setRate(quotation?.sales_rate)
            setSalesRate(quotation?.sales_rate)
            setStandardId(quotation?.workshop_standard_price_id)
            setInternalNotes(quotation?.internal_notes);
            setProjectstate(quotation?.project_part)
            setQuantityPrice(quotation?.quantity_based_price_breaks === true ? 'yes' : 'no')
            setDetailedBreakDown(quotation?.detailed_breakdown === true ? 'yes' : 'no')
            if (quotation?.labour != undefined) {
                setInput({
                    labour: +quotation?.labour,
                    parts: +quotation?.parts,
                    services: +quotation?.services,
                    equipment: +quotation?.equipment,
                    aog_fee: +quotation?.aog_fee,
                });
            }



        }
    }, [quotation]);
    useMemo(
        () =>
            setSum(
                +input.labour +
                +input.parts +
                +input.services +
                +input.equipment

            ),
        [input]
    );


    const createInitialProjectParts = async () => {
        let formData = new FormData()
        formData.append("organisation_id", getOrganisationId())
        formData.append("project_primary_part_id", selectedPart.id)

        projectParts.forEach((item, index) => {

            formData.append(`project_parts_data[${index}][labour]`, item.project_parts_labour || "0.00")
            formData.append(`project_parts_data[${index}][parts]`, item.project_parts_parts || "0.00")
            formData.append(`project_parts_data[${index}][service]`, item.project_parts_services || "0.00")
            formData.append(`project_parts_data[${index}][equip]`, item.project_parts_equipment || "0.00")
            formData.append(`project_parts_data[${index}][quantity]`, item.quantity || 0)
            formData.append(`project_parts_data[${index}][primary_part_id]`, item.primary_part_id)
            formData.append(`project_parts_data[${index}][reportable_type]`, "WorkshopOrder")
            formData.append(`project_parts_data[${index}][reportable_id]`, quotation?.workshop_order_id ? quotation?.workshop_order_id : workshopOrder.id ? workshopOrder.id : workshop_id_maint)

        })
        await MaintenanceServices.createInitialProjectParts(formData).then((res) => {

        }).catch((res) => {
            message.showToastMessage({
                message: res?.error ? res?.error : "Something went wrong. Try again!",
                variant: "error",
            });
        })

    }

    const updateAllPriceBreaks = async () => {

        for (let i = 0;i < priceBreakDetails.length;i++) {
            priceAllDetails.push({
                id: priceBreakDetails[i].id,
                min_quantity: priceBreakDetails[i].min_quantity,
                discount: priceBreakDetails[i].discount,
                unit_price: sum * (1 - (priceBreakDetails[i].discount / 100))

            })
        }
        const params = {
            "price_breaks": priceAllDetails
        }
        await MaintenanceServices.updateAllPriceBreaks(params).then((res) => {
            console.log("successs")
        }).catch((res) => {
            message.showToastMessage({ message: "Something went wrong!!", variant: "error" });
        })

    }


    const handleSubmit = (e) => {
        e.preventDefault();
        if (["send_quote", "save_for_later"].includes(actions)) {
            const formData = new FormData(e.target);
            if (actions === "send_quote") {
                const { error, valid } = validateFormData(
                    formData,
                    "internal_notes"
                );

                if (!valid) {
                    message.showToastMessage({
                        message: "Complete all mandatory fields!",
                        variant: "error",
                    });
                    setLoading(null);
                    setErrors(error);
                    return;
                }
            }
            updateAllPriceBreaks();
            const shippingFee = +states.man_hours || 0;
            const aogFee = +input.aog_fee || 0;
            const otherFee = shippingFee + aogFee;

            setPopUpValues({
                tat_days: tatQuantity,
                labour_value: input.labour,
                parts_value: input.parts,
                service_value: input.services,
                equipment_value: input.equipment,
                aog_fee: input.aog_fee,
                shipping: shippingFee,
                total: sum + otherFee,
            });



            /* ---------- FormData append ---------- */

            formData.append("workshop_order_id", workshop_order_id);
            formData.append("part_number", selectedPart?.part_number ? selectedPart?.part_number : "");
            formData.append("primary_part_id", selectedPart?.id ? selectedPart?.id : "");
            formData.append("project_part", projectState ? true : false);
            formData.append("user_id", getUserId());
            formData.append("quote_by", getUserId());
            formData.append("quantity", "1");
            formData.append("organisation_id", getOrganisationId());

            if (standardId !== null && standardId !== undefined) {
                formData.append("workshop_standard_price_id", standardId);
            }

            if (internalFiles.length > 0) {
                internalFiles.forEach(file =>
                    formData.append("internal_files[]", file)
                );
            }

            if (cusExist === "yes" && selectedCustomerId !== undefined) {
                formData.append("line_customer_id", selectedCustomerId.id || "");
            } else if (cusExist === "no") {
                formData.append("line_customer_id", "");
            } else {
                return;
            }
            setPayload(formData);
            if (projectState === true) {
                if (projectParts.length > 0 && (quoteId === null || quoteId === undefined) || reportableType === "PrimaryPart") {
                    createInitialProjectParts();
                }
            }
            if (actions === "send_quote") {
                setQuotePreview(true);
            }

            if (actions === "save_for_later") {
                const params = {
                    preview: false,
                    approved: false,
                    save_later: true,
                    quotation_id: quoteId ?? ""
                }
                const message1 = "Quote Saved Successfully !"
                sendQuotations(params, formData, message1)
                setLoading("save_for_later")
            }

        }
    };
    const sendQuotations = async (params, payload, message1 = null) => {
        if (actions === "send_quote") {
            setLoading("send_quote")
            setMessagePopup(true)
        }
        try {
            const response = await MaintenanceServices.createQuotationAndPreview(params, payload)
            if (response) {
                if (!quoteStatus || quoteId === null || quoteId === undefined) {
                    handleClose()

                }
                getMaintenanceOrderList()

                if (quoteId) {
                    getQuotation()
                    if (quoteStatus) {
                        getWorkshopOrderDetails()
                        setDisabled(true)
                    }
                }
                setState((ps) => ({ ...ps, isEditing: editTab, warningState: false, warningDialogState: false }));
                setInternalFiles([])
                message.showToastMessage({
                    message: message1 ? message1 : response?.message ? response?.message : "Quote Sent Successfully",
                    variant: "success",
                });
            }
        }
        catch {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
        }
        finally {

            setLoading(false)
            setMessagePopup(false)
            setButton(false)
            setActions(null)
        }



    }

    // actions

    const _props = {
        errors,
        setErrors,
        resetErrorsHandler,
        disabled,
        selectedCustomerId,
        setSelectedCustomerId,
        quotation,
        setQuotation,
        handlePopup,
        salesRate,
        setSalesRate,
        setRate,
        loading, actions, setActions,
        selectedPart, setSelectedPart,
        input, setInput,
        disabledAccptance,
        setDisabledAcceptance,
        cusExist, setExistCus,
        currentSelectedData,
        setCurrentSelectedData,
        setLoading,
        qty, setQty,
        currencyName,
        setCurrencyname,
        projectState,
        setProjectstate,
        sum,
        setSum,
        internalNotes,
        setInternalNotes,
        internalFiles,
        setInternalFiles,
        busy,
        quantityPrice,
        setQuantityPrice,
        detailedBreakDown,
        setDetailedBreakDown,
        getQuotation,
        setBusy,
        priceBreakDetails,
        setPriceBreaksDetails,
        quoteComments,
        setQuoteComments,
        updateAllPriceBreaks,
        handleCloseTab,
        access,
        states, setStates, tatQuantity,
        setTatquantity,
        workshop_order_id,
        setProjectParts,
        rate,
        projectParts,
        setStandardId,
        quoteId,
        isGettingDetails,
        reportableType, setReportableType,
        setWorkshopOrderId,
        ...props
    }






    return (
        <>
            <Grid className={classes.paper}>
                <form onSubmit={handleSubmit} noValidate>
                    <CustomerSection  {..._props} />
                    <WorkScopeSection {..._props} />
                    <ProjectPartSection  {..._props} />
                    <PricingSection {..._props} />

                    <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingBottom: '15px'
                    }}>


                        {props?.tabState === 1 && props?.permission.write && !quoteStatus &&
                            <MROButton
                                disabled={
                                    quoteStatus === true ||
                                    quoteStatus === undefined ||
                                    quoteStatus === null
                                }
                                loading={loading === "save_for_later"}
                                style={{
                                    marginRight: "15px",
                                    display: access.read ? "none" : undefined,
                                }}
                                variant={"contained"}
                                type="submit"
                                onClick={() => handleSaveForLater()}
                            >
                                Save for later
                            </MROButton>

                        }
                        {props?.tabState === 1 && props?.permission.write && (!quoteStatus || button) && (
                            <MROButton
                                loading={updateQuoteLoading === "loading"}
                                variant={"contained"}
                                type={"submit"}
                                disabled={!props.permission.write}
                                // color={theme.palette.secondary.main}
                                style={{
                                    backgroundColor: !props.permission.write ? "#F5F5F5" : theme.palette.secondary.main,
                                    color: "white",
                                    display: access.read ? "none" : undefined,
                                }}
                                onClick={() => {

                                    setActions("send_quote")
                                    handleWarningDialog();
                                }}
                            >
                                Send Quote
                            </MROButton>)}
                        {props?.tabState === 1 && props?.permission.write && quoteStatus && !button &&
                            <MROButton
                                loading={loading === "unlock"}
                                variant={"contained"}
                                type={"button"}
                                disabled={!props.permission.write}
                                // color={theme.palette.secondary.main}
                                style={{
                                    backgroundColor: !props.permission.write ? "#c2bebe" : "#FFB300",
                                    color: "white",
                                    display: access.read ? "none" : undefined,
                                }}
                                onClick={() => handleQuoteUnlockButton()}
                            >
                                <Box display="flex" justifyContent="center">
                                    {" "}
                                    <img
                                        src={UnlockIcon}
                                        alt="Icon"
                                        style={{ height: "18px" }}
                                    />
                                    &nbsp;&nbsp;{"Unlock"}
                                </Box>
                            </MROButton>

                        }
                    </div>
                </form>



            </Grid>
            <br />
            <AcceptanceSection {..._props} />

            {quotePreview && actions === "send_quote" && <QuotePreview
                handleClose={() => setQuotePreview(false)}
                open={quotePreview}
                popupValues={popupValues}
                quotationId={quoteId}
                workshopOrderId={workshop_order_id}
                payload={payload}
                sendQuotations={sendQuotations}
                handleWarningDialog={handleWarningDialog}
                setQuoteId={setQuoteId}
                getQuotation={getQuotation}
                setInternalFiles={setInternalFiles}
                internalFiles={internalFiles}
                setReportableType={setReportableType}
                projectState={projectState}
            />}
            {messagePopup &&
                <MessagePopup
                    handleClose={() => setMessagePopup(false)}
                    open={messagePopup}
                    topTitle={"The Quote Report for the job are being prepared"}
                    bottomTitle={"Please be patient, this will take a few moments"}

                />}
        </>

    );
}

export default Quote;
